import { useQuery as c } from "react-query";
import { useAuth as u } from "../../../auth/hooks/useAuth.js";
import { useEnvironment as m } from "../../../common/hooks/environment/useEnvironment.js";
import { getAdapter as p } from "../../adapter.js";
import { ScopeAdapter as f } from "../../models/scope/scope.adapter.js";
function g(e = {}) {
  const {
    backendBaseUrl: r
  } = m(), {
    token: n,
    scope: s
  } = u();
  return c({
    queryKey: ["userPaymentMethodUrl"],
    queryFn: async () => {
      const t = await fetch(`${r}/user/access/payment-method/`, {
        method: "POST",
        headers: {
          Authorization: `Token ${n}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          scope: p(f).serialize(s)
        })
      });
      if (t.status !== 200)
        throw new Error("Cannot get payment method page");
      const i = await t.json(), { url: a } = i, o = new URL(a);
      return e != null && e.noTitle && o.searchParams.set("no_title", "true"), o.toString();
    },
    refetchOnWindowFocus: !1,
    keepPreviousData: !1
  });
}
export {
  g as useGetPaymentMethodsUrl
};
//# sourceMappingURL=useGetPaymentMethodsUrl.js.map
